<template>
  <el-dialog
    title="新增"
    :visible="isShow"
    width="500px"
    destroy-on-close
    :before-close="closeDialog"
  >
    <el-form ref="formDataRef" :model="formData" :rules="rules" label-width="60px">
      <el-form-item label="姓名" prop="userName">
        <el-input v-model="formData.userName" placeholder="请输入新增的姓名" />
      </el-form-item>
      <el-form-item label="区域" prop="areaId">
        <el-select
          v-model="formData.areaId"
          filterable
          remote
          clearable
          :remote-method="queryAreaList"
          placeholder="请输入新增的区域名称"
          style="width: 100%"
          @change="getCurrentAreaName"
        >
          <el-option
            v-for="item in areaList"
            :key="item.areaId"
            :label="item.areaName"
            :value="item.areaId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="部门" prop="deptCode">
        <el-select
          v-model="formData.deptCode"
          filterable
          remote
          clearable
          :remote-method="queryDeptList"
          placeholder="请输入新增的部门名称"
          style="width: 100%"
          @change="getCurrentDeptName"
        >
          <el-option
            v-for="item in deptList"
            :key="item.id"
            :label="`${item.deptName}(${item.newDept ? '新' : '旧'})`"
            :value="item.deptCode"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitFormData">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAreaInfoList, getDeptInfoList, saveBusinessShip } from '@/API';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      deptList: [],
      areaList: [],
      formData: {},
      rules: {
        userName: [
          { required: true, message: '请输入新增的姓名', trigger: 'blur' }
        ],
        areaId: [
          { required: true, message: '请输入新增的区域名称', trigger: 'blur' }
        ],
        deptCode: [
          { required: true, message: '请输入新增的部门名称', trigger: 'blur' }
        ]
      }
    };
  },

  methods: {
    openDialog () {
      this.isShow = true;
      this.formData = {};
    },

    closeDialog () {
      this.isShow = false;
      this.deptList = [];
      this.areaList = [];
      this.formData = {};
    },

    getCurrentAreaName (val) {
      let item = this.areaList.find(row => row.areaId === val);
      this.formData.areaName = item.areaName;
    },

    getCurrentDeptName (val) {
      let item = this.deptList.find(row => row.deptCode === val);
      this.formData.deptName = item.deptName;
    },

    // 获取区域
    queryAreaList (val) {
      if (val === '') return;
      getAreaInfoList({ areaName: val }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          this.areaList = data;
        }
      });
    },

    // 获取部门
    queryDeptList (val) {
      if (val === '') return;
      getDeptInfoList({ deptName: val }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          this.deptList = data;
        }
      });
    },

    submitFormData () {
      this.$refs.formDataRef.validate((state) => {
        if (state) {
          this.isLoading = true;
          saveBusinessShip(this.formData)
            .then(res => {
              const { status, data } = res.data;
              this.isLoading = false;
              if (status === '200' && data) {
                this.$emit('on-ok');
                this.$message.success('添加成功');
                this.closeDialog();
              }
            }).catch(() => {
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>
